import { render, staticRenderFns } from "./RecognitionTable.vue?vue&type=template&id=007de96e&scoped=true&"
import script from "./RecognitionTable.vue?vue&type=script&lang=js&"
export * from "./RecognitionTable.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionTable.vue?vue&type=style&index=0&id=007de96e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007de96e",
  null
  
)

export default component.exports